import { useState } from 'react';
import { usePanelActions } from '../../../actions';
import { TUsePanelFooter } from './usePanelFooter';
import { AutoEllipsis, SimpleButton } from '@apia/components';
import { Box } from '@apia/theme';

export const PanelFooter = ({
  footerContent,
  isRefreshable,
  footer,
  force,
  handleFooterClick,
}: TUsePanelFooter & { isRefreshable: boolean; force?: boolean }) => {
  const [lastUpdate, setLastUpdate] = useState<number>(0);

  usePanelActions({
    refresh() {
      setLastUpdate(Date.now());
    },
  });

  return (
    <>
      {(isRefreshable || footer || force) && (
        <div className="panel__footer">
          {footerContent ??
            (footer &&
              (!footer.action || footer.actionBehavior === 'DO_NOTHING') && (
                <div className="panel__footer__text">
                  <AutoEllipsis
                    overrideStyles={(el) => {
                      const styles = window.getComputedStyle(
                        el.closest('.panel__footer') as HTMLElement,
                      );
                      const width = Number.parseInt(styles.width, 10);
                      const padding =
                        Number.parseInt(styles.paddingLeft, 10) +
                        Number.parseInt(styles.paddingRight, 10);
                      return {
                        width: `${width - padding}px`,
                      };
                    }}
                  >
                    {footer.text}
                  </AutoEllipsis>
                </div>
              ))}
          {footer?.action && footer.actionBehavior !== 'DO_NOTHING' && (
            <SimpleButton
              onClick={handleFooterClick}
              onDoubleClick={handleFooterClick}
              variant="link"
              className="panel__footer__text"
            >
              <AutoEllipsis
                overrideStyles={(el) => {
                  const styles = window.getComputedStyle(
                    el.closest('.panel__footer') as HTMLElement,
                  );
                  const width = Number.parseInt(styles.width, 10);
                  const padding =
                    Number.parseInt(styles.paddingLeft, 10) +
                    Number.parseInt(styles.paddingRight, 10);
                  return {
                    width: `${width - padding}px`,
                  };
                }}
              >
                {footer.text}
              </AutoEllipsis>
            </SimpleButton>
          )}
          {!footer && <div></div>}
          {lastUpdate > 0 && (
            <Box className="lastUpdate__wrapper">
              {new Date(lastUpdate).toLocaleDateString()}{' '}
              {new Date(lastUpdate).toLocaleTimeString()}
            </Box>
          )}
        </div>
      )}
    </>
  );
};
